import { css } from '@emotion/react';

import EFinderImage, {
  EFinderImageSizes,
} from '@components/common/EFinderImage';
import SvgIcon from '@components/common/SvgIcon';

import ProfileImg from '@public/icons/profile_32.svg';

import { IEFinderObject } from '@model';
import { CSSProps } from '@utils/misc';

const avatarWrapCSS = (size: number) => css`
  position: relative;
  width: ${size}px;
  height: ${size}px;
`;

const avatarCSS = (size: number, blurValue: number | undefined) => css`
  position: relative;
  width: ${size}px;
  height: ${size}px;
  border-radius: 100px;
  overflow: hidden;
  img {
    ${blurValue ? `filter: blur(${blurValue}px)` : null};
  }

  i {
    display: block;
  }
`;

export interface IRoundAvatar {
  size?: number;
  picture?: IEFinderObject<'image'>;
  imageSize?: EFinderImageSizes;
  blurValue?: number;
}

const RoundAvatar = ({
  size = 44,
  picture,
  className,
  blurValue,
  imageSize = EFinderImageSizes.avatar,
}: IRoundAvatar & CSSProps) => {
  return (
    <div css={avatarWrapCSS(size)} className={className}>
      <div css={avatarCSS(size, blurValue)} className={'avatar-container'}>
        {picture && picture.key ? (
          <EFinderImage image={picture} h={imageSize} radius={100} />
        ) : (
          <SvgIcon icon={ProfileImg} d={size} />
        )}
      </div>
    </div>
  );
};

export default RoundAvatar;
